module.exports = __webpack_public_path__ + "img/بطيخ-صورة.58a102e3.png";